import { TeamMembership } from '@enview/interface/types/Team';

export const AVATAR_COLOR_COUNT = 8;

/** The member fields that avatars and member pickers read. */
export type AvatarMember = Pick<
  TeamMembership,
  'organizationUserId' | 'firstName' | 'lastName' | 'email'
>;

export const getDisplayName = (member: AvatarMember): string => {
  const fullName = `${member.firstName ?? ''} ${member.lastName ?? ''}`.trim();
  return fullName || member.email || `Member ${member.organizationUserId}`;
};

export const getInitials = (member: AvatarMember): string => {
  if (member.firstName || member.lastName) {
    return `${(member.firstName ?? '').charAt(0)}${(member.lastName ?? '').charAt(
      0,
    )}`.toUpperCase();
  }
  const parts = getDisplayName(member).trim().split(/\s+/);
  const first = parts[0]?.charAt(0) ?? '';
  const last = parts.length > 1 ? parts[parts.length - 1].charAt(0) : '';
  return `${first}${last}`.toUpperCase();
};

export const getAvatarColorClass = (organizationUserId: number): string =>
  `avatar-color-${organizationUserId % AVATAR_COLOR_COUNT}`;
